import { Share, Plus, MoreVertical, Download } from "lucide-react";
import PageLayout from "@/components/PageLayout";

const Install = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  const isMobile = isIOS || isAndroid;

  return (
    <PageLayout>
      <div className="min-h-screen bg-background pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-2xl">
          <div className="text-center mb-12">
            <div className="w-20 h-20 mx-auto mb-6 rounded-2xl overflow-hidden shadow-lg">
              <img 
                src="/lovable-uploads/black-favicon-512.png" 
                alt="DEL(PHI) App Icon"
                className="w-full h-full object-cover"
              />
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-3">Install DEL(PHI)</h1>
            <p className="text-muted-foreground">
              Add DEL(PHI) to your home screen for the best experience
            </p>
          </div>

          {isIOS ? (
            <div className="space-y-6">
              <h2 className="text-xl font-semibold text-foreground text-center mb-6">
                Install on iPhone/iPad
              </h2>
              
              <div className="bg-card border border-border rounded-lg p-6 space-y-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold">
                    1
                  </div>
                  <div>
                    <p className="text-foreground font-medium">Tap the Share button</p>
                    <p className="text-muted-foreground text-sm mt-1">
                      Look for the <Share className="inline w-4 h-4" /> icon at the bottom of Safari
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold">
                    2
                  </div>
                  <div>
                    <p className="text-foreground font-medium">Scroll down and tap "Add to Home Screen"</p>
                    <p className="text-muted-foreground text-sm mt-1">
                      Look for the <Plus className="inline w-4 h-4" /> Add to Home Screen option
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold">
                    3
                  </div>
                  <div>
                    <p className="text-foreground font-medium">Tap "Add"</p>
                    <p className="text-muted-foreground text-sm mt-1">
                      The app will appear on your home screen
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : isAndroid ? (
            <div className="space-y-6">
              <h2 className="text-xl font-semibold text-foreground text-center mb-6">
                Install on Android
              </h2>
              
              <div className="bg-card border border-border rounded-lg p-6 space-y-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold">
                    1
                  </div>
                  <div>
                    <p className="text-foreground font-medium">Tap the menu button</p>
                    <p className="text-muted-foreground text-sm mt-1">
                      Look for the <MoreVertical className="inline w-4 h-4" /> icon in Chrome
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold">
                    2
                  </div>
                  <div>
                    <p className="text-foreground font-medium">Tap "Install app" or "Add to Home screen"</p>
                    <p className="text-muted-foreground text-sm mt-1">
                      Look for the <Download className="inline w-4 h-4" /> Install option
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold">
                    3
                  </div>
                  <div>
                    <p className="text-foreground font-medium">Tap "Install"</p>
                    <p className="text-muted-foreground text-sm mt-1">
                      The app will be added to your home screen
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="space-y-8">
              <div className="bg-card border border-border rounded-lg p-6">
                <h2 className="text-xl font-semibold text-foreground mb-4">
                  📱 On iPhone/iPad (Safari)
                </h2>
                <ol className="space-y-3 text-muted-foreground">
                  <li className="flex gap-3">
                    <span className="text-primary font-medium">1.</span>
                    <span>Tap the <Share className="inline w-4 h-4" /> Share button at the bottom</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-primary font-medium">2.</span>
                    <span>Scroll down and tap "Add to Home Screen"</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-primary font-medium">3.</span>
                    <span>Tap "Add" in the top right</span>
                  </li>
                </ol>
              </div>

              <div className="bg-card border border-border rounded-lg p-6">
                <h2 className="text-xl font-semibold text-foreground mb-4">
                  🤖 On Android (Chrome)
                </h2>
                <ol className="space-y-3 text-muted-foreground">
                  <li className="flex gap-3">
                    <span className="text-primary font-medium">1.</span>
                    <span>Tap the <MoreVertical className="inline w-4 h-4" /> menu button</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-primary font-medium">2.</span>
                    <span>Tap "Install app" or "Add to Home screen"</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-primary font-medium">3.</span>
                    <span>Tap "Install" to confirm</span>
                  </li>
                </ol>
              </div>
            </div>
          )}

          <div className="mt-12 text-center">
            <div className="bg-muted/50 rounded-lg p-6">
              <h3 className="text-foreground font-medium mb-2">What you'll get</h3>
              <ul className="text-muted-foreground text-sm space-y-1">
                <li>✓ Full-screen app experience</li>
                <li>✓ Quick access from your home screen</li>
                <li>✓ Works offline for cached content</li>
                <li>✓ Faster loading times</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Install;
